<template>
	<div id="balance">
		<div class="balance-header">
      <div class="filter-date">
        <el-date-picker
          class="date-picaker"
          v-model="exportBalanceTime"
          type="daterange"
          range-separator=" ~ "
          align="left"
          placeholder="选择日期范围"
          unlink-panels
          :picker-options="pickerOptions">
        </el-date-picker>
      </div>
      <div class="export-balance-detail">
        <div class="new-funtion-tip-box" v-if="showNewFuntion">
          <div class="new-funtion-tip">
            现支持下载所有订单明细！
            <div class="know-btn" @click="onReadNewFuntion">我知道了</div>
          </div>
          <span :class="['nail']"></span>
        </div>
        <button class="s-btn btn-blue is-plain" :disabled="loading" @click="exportBalance">
          <i v-show="loading" class="el-icon-loading"></i>下载Excel
        </button>
      </div>
    </div>

    <!-- OSS，有一套一样的页面和逻辑，所有修改，记得同步 -->
		<table class="list-header" rules="groups" frame="box">
			<thead>
				<tr>
					<th width="180px">时间</th>
					<th class="text-center">余额变化 (元)</th>
					<th class="text-center">操作人</th>
					<th class="text-center">事由</th>
					<th width="200px" class="text-center">备注</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(v,k) in balances" :key="k">
					<td>{{v.update_time}}</td>
          <td class="text-center">
            <!-- oss，同业查看有一套一样的判断，记得同步 -->
            <span v-if="[2,3,5,9,13,17,18,19,20,21,23, 24].indexOf(v.balance_type) > -1">－{{v.balance_change / 100}}</span>
            <span class="fg-orange" v-else-if="[0,1,4,6,7,8,10,11,12,14,15,16,22,25,26,27,28,29].indexOf(v.balance_type) > -1">＋{{v.balance_change / 100}}</span>
          </td>
          <!-- <td class="text-center" v-if="[23, 24].indexOf(v.balance_type) > -1">-</td> -->
					<!-- <td class="text-center" v-if="[2,3,5,9,13,17,18,19,20,21,23, 24].indexOf(v.balance_type) > -1">－{{v.balance_change / 100}}</td> -->
					<!-- <td v-else-if="[0,1,4,6,7,8,10,11,12,14,15,16,22,25,26,27,28,29].indexOf(v.balance_type) > -1" class="fg-orange text-center">＋{{v.balance_change / 100}}</td> -->
          <!-- 这里如果后续增加了其它事由，改动后要同步把 getExportData 也改一下，否则导出的文件相应数据会出现错误 -->
					<td class="text-center">{{v.name}}</td>
					<td class="text-center">{{v.cause_str || $maps.balanceType[v.balance_type]}}</td>
					<td class="text-center list-td-memo" style="">
            <template v-if="+v.enable_api">
              {{v.memo}}
              <div class="api-tag"></div>
            </template>
            <template v-else>
              <a class="fg-blue" target="_blank"
                :href="v.insure_detail" v-if="v.insure_detail">
                投保单号:
                {{v.insurance_num}}
              </a>

              <router-link
                :to="{name: 'orderDetail', params: {oid: v.user_order_id}}"
                class="fg-blue"
                v-else-if="v.user_order_id"
                style="display:inline-block">{{v.memo}}</router-link>

              <template v-else>
                {{v.memo}}
              </template>
            </template>
					</td>
				</tr>
			</tbody>
		</table>

    <div v-if="!balances.length" class="no-data">
      <img class="nodata-img" src="../../../assets/imgs/new-user/balance-nodata.png" alt="">
      <div class="nodata-text">未查询到消费记录</div>
    </div>

		<div class="page" v-if="totalCount">
			<el-pagination
				class="text-center"
				@current-change="getData"
				:current-page.sync="page"
				:page-size="10"
				layout="total, prev, pager, next"
				:total="totalCount" >
	   	 	</el-pagination>
		</div>
  </div>
</template>

<script>
import moment from 'moment';
import sensorsdata from 'sa-sdk-javascript';
import { Message } from 'element-ui';
import JsonExcel from 'vue-json-excel';
import utils from '../../../libs/utils';
import Http from '../../../libs/http';
import User from '../../../libs/user';
import exportService from '../../../services/export-service';
import { ORDER_ENABLE_API_MAP } from '@/maps/order-maps';

export default {
  components: {
    JsonExcel,
  },
  data() {
    return {
      queryParams: { currentPage: 1 },
      popBox: false,
      balances: [],
      page: 1,
      totalCount: 0,
      peer: User.peer || {},
      exportBalanceTime: [null, null],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: '最近一年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: '全部',
          onClick(picker) {
            picker.$emit('pick', []);
          },
        }],
      },
      loading: false,
      json_data: [],
      filename: '',
      json_fields: {
        时间: 'update_time',
        '余额变化（元）': 'balance_change',
        '剩余余额（元）': 'balance_amount',
        操作人: 'name',
        事由: 'cause_str',
        备注: 'memo',
        国家: 'country',
        商品名称: 'product_name',
        API订单: 'enable_api',
      },
      showNewFuntion: false, // 是否提示新功能-下载excel
    };
  },
  watch: {
    exportBalanceTime() {
      this.page = 1;
      this.getData(1);
    },
  },
  methods: {
    getBalanceData(obj) {
      Http.post('/peer_balance_brief_query', obj).then((data) => {
        this.balances = data.page_data || data;
        this.totalCount = data.total_count || 0;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    getData(page) {
      const obj = {
        page,
      };

      if (this.exportBalanceTime.length > 0 && this.exportBalanceTime[0]) {
        obj.begin_date = utils.formatDate(this.exportBalanceTime[0], 'yyyy-MM-dd');
        obj.end_date = utils.formatDate(this.exportBalanceTime[1], 'yyyy-MM-dd');
      }

      this.getBalanceData(obj);
    },
    // 我知道了
    onReadNewFuntion() {
      this.showNewFuntion = false;
      const storageData = localStorage.getItem('balancePage') ? JSON.parse(localStorage.getItem('balancePage')) : {};
      storageData.downloadExcel = storageData.downloadExcel || [];
      storageData.downloadExcel.push(User.peer_account_id);
      localStorage.setItem('balancePage', JSON.stringify(storageData));
    },
    getExportData() {

      const obj = {
        // is_export: 1,
        page: 1,
      };

      if (this.exportBalanceTime.length > 0 && this.exportBalanceTime[0]) {
        obj.begin_date = utils.formatDate(this.exportBalanceTime[0], 'yyyy-MM-dd');
        obj.end_date = utils.formatDate(this.exportBalanceTime[1], 'yyyy-MM-dd');
      }

      const filename = `消费账单_${moment(new Date()).format('YYYYMMDDHHmmss')}`;

      return new Promise((resolve, reject) => {
        Http.post('/peer_balance_export', obj).then((data) => {

          if (!data.order_data.length) {
            Message.warning({
              message: '无消费账单可导出',
            });
            resolve();
            return;
          }
          const { exportHeader: totalHeader, exportData: totalExportData } = this.createTotalDataExcelSheet(data);
          const { exportHeader: orderHeader, exportData: orderExportData } = this.createOrderDataExcelSheet(data);
          // const { exportHeader: otherHeader, exportData: otherExportData } = this.createOtherDataExcelSheet(data);


          exportService.exportIntoXLSXByJsonList(
            [totalExportData, orderExportData],
            [totalHeader, orderHeader],
            `${filename}.xlsx`,
            ['周期内总计', '订单明细'],
            ['aoa'], // 指定周期内总计输入为aoa
          );

          resolve([totalExportData, orderExportData]);
        }).catch((e) => {
          if (e) console.log(e);
          reject();
        });
      });
    },
    createTotalDataExcelSheet(data) {
      const exportHeader = {
        total_visa_order_amount: '总签证订单金额',
        total_insurance_order_amount: '总保险订单金额',
        total_other_amount: '其他收支',
        balance_amount: '周期内结余',
      };


      const exportData = [
        [],
        [`指标口径：${data.total_data.date_range_str}`, null],
        [],
      ];

      Object.keys(exportHeader).forEach((key) => {
        exportData.push([
          exportHeader[key], (data.total_data[key] || 0) / 100,
        ]);
      });

      return {
        exportHeader,
        exportData,
      };
    },
    createOrderDataExcelSheet(data) {
      const exportHeader = {
        cause_str: '事由',
        balance_change: '金额',
        balance_amount: '剩余金额',
        name: '操作人',
        update_time: '费用发生时间',
        memo: '备注',
        user_order_id: '订单号', 
        product_type_desc: '商品类型',
        country: '商品目的地',
        product_name: '商品全称',
        order_status_desc: '订单状态',
        enable_api: 'API订单',
        pay_time: '订单支付时间', 
        applicant_name: '申请人', 
        applicant_count: '申请人数量',
        applicant_status_desc: '申请人状态',
        // applicant_desc: '出签时间',
      };

      const exportData = [];
      data.order_data.forEach((item) => {
        
        const obj = {
          cause_str: item.cause_str,
          balance_change: item.balance_change / 100,
          balance_amount: item.balance_amount / 100,
          name: item.name,
          update_time: item.update_time,
          memo: item.memo,
          user_order_id: item.user_order_id,
          product_type_desc: item.product_type_desc,
          country: item.country,
          product_name: item.product_name,
          order_status_desc: item.order_status_desc,
          enable_api: ORDER_ENABLE_API_MAP[item.enable_api], // 兼容不需要显示的情况
          pay_time: item.pay_time,
          applicant_name: item.applicant_name,
          applicant_count: item.applicant_count,
          applicant_status_desc: item.applicant_status_desc,
        // applicant_desc: item.applicant_desc,
        };
        exportData.push(obj);
      });
      
      
      // 添加上总额
      exportData.push({
        cause_str: '总计',
        balance_change: data.total_data.balance_amount / 100, // 整数相加
      });
      
      return {
        exportHeader,
        exportData,
      };
    },
    async exportBalance() {
      this.loading = true;

      try {
        const exportData = await this.getExportData();
        this.loading = false;

      } catch (e) {
        this.loading = false;
      }
      // return exportData;
    },
    clickExportBtn(e) {
      sensorsdata.quick('trackHeatMap', e.target);
    },
  },
  created() {
    const _this = this;

    Http.post('/peer_account_query', {}).then((data) => {
      if (!data.wxinfo && !User.is_palmyou) {
        this.$router.replace({ name: 'bind', query: { redirectUrl: encodeURIComponent(this.$route.fullPath) } });
      }
    }).catch((e) => {
      if (e) console.log(e);
    });

    Http.post('/visa_peer_query').then((data) => {
      _this.peer = data;
      utils.extend(User.peer, data);


      // 是否显示新功能--- 老用户 & 上线一个月内 & 没点击过我知道了
      const isOldUser = User.peer.is_new_peer === 0; // 老用户，并且后端还会返回null也不需要展示
      const storageData = localStorage.getItem('balancePage') ? JSON.parse(localStorage.getItem('balancePage')) : {};
      const isClicked = storageData.downloadExcel ? storageData.downloadExcel.includes(User.peer_account_id) : false;
      this.showNewFuntion = isOldUser && !isClicked;
    }).catch((e) => {
      if (e) console.log(e);
    });

    this.getBalanceData({ page: 1 });
  },
};
</script>

<style lang="less" scoped>
@import  '../../../assets/less/variable';
#balance{
	padding: 24px;

  .balance-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .filter-date{
      .date-picaker{
        width: 340px;
        /deep/ .el-input__inner{
          height: 40px;
        }
      }
    }
    .export-balance-detail {
      display: flex;
      align-items: center;
      position: relative;
      .new-funtion-tip-box {
        .new-funtion-tip {
          position: absolute;
          padding: 6px 8px;
          font-size: 12px;
          color: #FFFFFF;
          line-height: 12px;
          display: flex;
          align-items: center;
          background: #599FFF;
          white-space: nowrap;
          border-radius: 2px;
          top: -60px;
          right: 6px; 
          &::before {
            content: "";
            position: absolute;
            right: 40.5px;
            bottom: -24px;
            width: 1px;
            height: 24px;
            background-color: #599FFF;
            z-index: 1;
          }
          &::after {
            content: "";
            position: absolute;
            right: 33px;
            bottom: -14px;
            border-top: 8px solid #599FFF;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
            border-bottom: 8px solid transparent;
          }
          .know-btn {
            flex-shrink: 0;
            margin-left: 16px;
            width: 64px;
            height: 20px;
            line-height: 20px;
            color: #599FFF;
            background: #FFFFFF;
            border-radius: 2px;
            text-align: center;
            cursor: pointer;
          }
        }
        .nail {
          position: absolute;
          right: 47px;
          top: 0;
          z-index: 1;

          &::after, &::before {
            content: '';
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            border-radius: 50%;
          }
          &::after {
            content: "";
            top: -6px;
            width: 12px;
            height: 12px;
            background: #CDE2FF;
          }
          &::before {
            content: "";
            top: -3px;
            width: 6px;
            height: 6px;
            background: #599FFF;
            z-index: 1;
          }
        }
      }
      .demonstration {
        font-size: 14px;
        color: #5e9be1;
        font-weight: normal;
        cursor: pointer;
        margin-left: 10px;
        .el-icon-loading {
          margin-right: 3px;
        }
      }
    }
  }
	.list-header{
		width:100%;
		font-size: 14px;
		margin: 24px 0 0 0;
    border: none;
    color: #2F333D;
    thead{
      border:1px solid #E9EEF2;
      th{
        background-color: #FAFBFC;
        padding: 0 16px;
        text-align: left;
        font-weight: 600;
        height: 60px;
      }
    }
    tbody{
      tr{
        border-bottom: 1px solid #E9EEF2;
        td{
          padding: 16px;
          height:68px;
			    background-color: #fff;
          word-break: break-all;
          &.list-td-memo{
            line-height: 20px;
            padding:16px 5px;
            display: flex;
            align-items: center;
            .api-tag{
              display: inline-block;
              flex-shrink: 0;
              height: 20px;
              width: 40px;
              background: url(../../../assets/imgs/new-user/icon-api.png) no-repeat center / 100% 100%;
              margin-left: 4px;
            }
          }
        }
      }
    }

		.items-sbtn{
			width:76px;
			height:26px;
			font-size: 13px;
		}
    .text-center{
      text-align: center;
    }

  }

  
 

  .no-data {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 0;
    .nodata-img{
      width: 200px;
      height: 120px;
    }
    .nodata-text{
      color: #91999F;
      font-size: 16px;
      margin-top: 11px;
    }
  }

	.el-button{
		width: 78px;
		height: 28px;
		padding:0;
	}
	.page{
		height:140px;
		position:relative;
		.text-center{
			position:absolute;
			top:50%;
			left:50%;
			transform:translate(-50%,-50%);
			-ms-transform:translate(-50%,-50%)
		}
	}

}
</style>



// WEBPACK FOOTER //
// src/pages/user/user-children/Balance.vue